function RectangleChecked(props) {
  return (
    <svg width="22" height="23" viewBox="0 0 22 23" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_67_1163)">
        <path
          d="M3.4375 12.781V4.53101C3.4375 4.34867 3.50993 4.1738 3.63886 4.04487C3.7678 3.91594 3.94266 3.84351 4.125 3.84351H17.875C18.0573 3.84351 18.2322 3.91594 18.3611 4.04487C18.4901 4.1738 18.5625 4.34867 18.5625 4.53101V18.281C18.5625 18.4633 18.4901 18.6382 18.3611 18.7671C18.2322 18.8961 18.0573 18.9685 17.875 18.9685H11.6875"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.4375 16.906L5.5 18.9685L10.3125 14.156"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_67_1163">
          <rect width="22" height="22" fill="white" transform="translate(0 0.406006)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default RectangleChecked;
